import React, { useState } from 'react';

import Modal from '@amzn/meridian/modal';
import { type AccommodationStatusResponseDto } from 'src/store/placementDetailsPageSlice/types';

import { type UpdateStatusContext, UpdateStatusProgress } from './constants';

import DecisionByLoginEntry from './statusUpdateForms/decisionByLoginEntry';
import DlsReferralFormEntry from './statusUpdateForms/dlsReferralFormEntry';
import StatusSelection from './statusUpdateForms/statusSelection';

interface UpdatePlacementStatusModalProps {
  open: boolean;
  ctx: UpdateStatusContext;
}

const UpdatePlacementStatusModal = ({ open, ctx }: UpdatePlacementStatusModalProps) => (
  <Modal
    title={'Update Status'}
    open={open}
    onClose={ctx.onClose}
    closeLabel="Close"
    aria-describedby="modal-description"
    width="416px"
  >
    <UpdatePlacementStatusModalContent ctx={ctx} />
  </Modal>
);

// Must store local state in child component of Modal because closed modals are still on the DOM but their children are not.
// This provides a predictable local state lifecycle (read: clears when modal is closed)
const UpdatePlacementStatusModalContent = ({ ctx }: { ctx: UpdateStatusContext }) => {
  const initialStatus = ctx.placement.statusOptions.find((val) => ctx.placement.placementStatus === val.status);
  const [selectedStatus, setSelectedStatus] = useState<AccommodationStatusResponseDto | undefined>(initialStatus);
  const [currentProgress, setProgress] = useState<UpdateStatusProgress>(UpdateStatusProgress.StatusSelection);

  if (currentProgress == UpdateStatusProgress.StatusSelection || !selectedStatus) {
    return <StatusSelection {...{ ctx, selectedStatus, setSelectedStatus, setProgress }} />;
  } else if (currentProgress == UpdateStatusProgress.DecisionByLoginEntry) {
    return <DecisionByLoginEntry {...{ ctx, selectedStatus, setProgress }} />;
  } else if (currentProgress == UpdateStatusProgress.DlsReferralFormEntry) {
    // collects info for a single status type and updates using its own API endpoint. selectedStatus is inferred implicitly
    return <DlsReferralFormEntry {...{ ctx, setProgress }} />;
  } else {
    return null;
  }
};

export default UpdatePlacementStatusModal;
